import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { WorkflowClient } from '@frontend/workflow/api';
import { Workflow, WorkflowQueryParams } from '@frontend/workflow/types';
import React, { useState } from 'react';

const ID = 'workflow-select';
export const WorkflowSelectV2 = (props: ObjectSelectProps<Workflow, WorkflowQueryParams>) => {
    const [v, cV] = useState<Workflow | null>(null);
    return (
        <ObjectSelectInput<Workflow, WorkflowQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Workflow'}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                cV(v);
            }}
            required={props.required}
            className={props.className}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(props) => WorkflowClient.fetchWorkflows(props)}
            itemLabel={(account) => account.name}
            isClearable={props.isClearable}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
        />
    );
};
